import React, { useState } from 'react';
import Link from 'next/link';
import { Card, Stack, Typography } from '@krakentech/coral';

import WheelOfFortune from '@/components/WheelOfFortune/WheelOfFortune/components/Wheel';
import { RewardBrand } from '@/types/rewards';
import { INTERNAL_PATHS } from '@/utils/urls';

type WheelOfFortuneProps = {
  isOpen: boolean;
  onClose: () => void;
  setIsSpinning: (isSpinning: boolean) => void;
  onSpinComplete?: (prize: RewardBrand) => void;
};

const WheelOfFortuneContainer = ({
  isOpen,
  onSpinComplete,
}: WheelOfFortuneProps) => {
  const [isSpinning, setIsSpinning] = useState(false);

  if (!isOpen) return null;

  const handleSpin = () => {
    setIsSpinning(true);

    setTimeout(() => {
      setIsSpinning(false);
      onSpinComplete?.(RewardBrand.ACCOUNT_CREDIT); // fixed prize since it's hardcoded for now
    }, 3000);
  };

  return (
    <Card>
      <Stack direction="vertical" gap="xl">
        <Stack direction="vertical" gap="xs">
          <Typography variant="h1" textAlign="center">
            Spin the wheel of fortune
          </Typography>
          <Typography variant="body2" textAlign="center">
            Click the wheel to spin and discover your reward!
          </Typography>
        </Stack>
        <WheelOfFortune
          isSpinning={isSpinning}
          onSpinComplete={onSpinComplete}
          onSpin={handleSpin}
        />

        <Link href={INTERNAL_PATHS.HOME.path}>
          <Typography textAlign="center" variant="h3">
            Back to account overview
          </Typography>
        </Link>
      </Stack>
    </Card>
  );
};

export default WheelOfFortuneContainer;
